import { motion } from 'framer-motion'
import { useRouter } from 'next/router'
import React, { useMemo } from 'react'

import { introLeftVariants, introOpacityVariants } from '@/config/const'
import { getHomeBusinessOpportunity } from '@/services/home'
import { HomeBusinessOpportunityListRequest } from '@/types/home'
import { useAppSelector } from '@/utils/hooks'

import BusinessOpportunitiesCard from './components/BusinessOpportunitiesCard'

const BusinessOpportunities: React.FC = () => {
  const router = useRouter()
  const requestList: HomeBusinessOpportunityListRequest = useMemo(() => {
    return {
      params: { skip: 0, limit: 1000 },
      headers: { 'Accept-Language': String(router.locale) },
    }
  }, [])

  const { data: businessOpportunity } = useAppSelector(getHomeBusinessOpportunity.select(requestList))

  if (businessOpportunity && businessOpportunity?.data.items.length > 0) {
    return (
      <div className='overflow-hidden bg-white'>
        <div className='container flex flex-col items-center gap-6 py-8 lg:gap-12.5 lg:pb-20 lg:pt-12.5'>
          <div className='flex flex-col items-center gap-4'>
            <motion.h2
              className='text-2xl font-bold md:text-3.5xl'
              initial='hide'
              whileInView='show'
              viewport={{ once: true }}
              variants={introLeftVariants}
            >
              {businessOpportunity?.data.title}
            </motion.h2>
            <motion.div
              className='description break-words text-center text-sm md:text-base'
              dangerouslySetInnerHTML={{ __html: businessOpportunity?.data.description }}
              initial='hide'
              whileInView='show'
              viewport={{ once: true }}
              variants={introOpacityVariants}
            />
          </div>
          <div className='flex w-full flex-col justify-center gap-x-6 gap-y-6 md:flex-row lg:gap-y-11'>
            {businessOpportunity?.data.items.map((item, idx) => (
              <BusinessOpportunitiesCard
                key={item.xid}
                title={item.title}
                message={item.description}
                isLeft={idx % 2 === 0}
                icon={item.iconFiles}
                background={item.imageFiles}
              />
            ))}
          </div>
        </div>
      </div>
    )
  }
  return null
}

export default BusinessOpportunities
